import { MeatballsLoader } from "./meatballs-loader";

const sizes = ["sm", "default", "md", "lg"] as const;
const speeds = ["slow", "normal", "fast"] as const;

interface SpinnerProps {
	className?: string;
	size?: (typeof sizes)[number];
	speed?: (typeof speeds)[number];
}

/**
 * Unified loading indicator: the compact **meatballs** loader (three tightly
 * packed dots pulsing in a staggered wave). This is the default small / inline
 * loader across the app — buttons, phone selector, list rows, etc.
 *
 * For search inputs and page / big-component loading, reach for the roomier
 * `<DotsLoader />` instead.
 *
 * Color inherits from the parent's `text-*` via `bg-current`, so it adapts to
 * context and dark mode automatically.
 *
 * @example
 * <Spinner />
 * <Spinner size="lg" speed="fast" />
 * <Spinner className="text-primary" />
 */
function Spinner({
	size = "default",
	speed = "normal",
	className,
}: SpinnerProps) {
	return <MeatballsLoader className={className} size={size} speed={speed} />;
}

export { Spinner };
